<template>
    <section class="home-page__01" :style="`background-image: url(${VIDEO_TOP_BG})`">
        <video muted preload class="bg" id="home-page01-video" autoplay loop :src="VIDEO_TOP" @canplaythrough="loaded"></video>
        <div class="logotip-wrap">
            <img class="logo" src="../../assets/images/logo.png" alt="logo">
            <!-- <div class="comingsoon">
                <img src="../../assets/images/home/page01/comingsoon_btn.png" alt="">
            </div> -->
            <!-- <router-link to="/pre_registration" class="tip">
                <img src="../../assets/images/home/page01/prelogin.png" alt="">
            </router-link> -->
            <div class="tip-wrap">
                <img src="../../assets/images/home/page01/top_release.png" class="tip-text" alt="">
            </div>
            <div class="download-btn-wrap">
                <img src="../../assets/images/home/page01/dl_button.png" class="download-img" alt="">
                <div class="download-a-wrap">
                    <a href="https://apps.apple.com/jp/app/epic-seven/id1322399438" target="_blank" class="download-a--ios"></a>
                    <a href="https://play.google.com/store/apps/details?id=com.stove.epic7.google" target="_blank" class="download-a--android"></a>
                </div>
            </div>
        </div>
        <img class="slogan" src="../../assets/images/home/page01/slogan.png" alt="slogan">
        <scroll-bar></scroll-bar>
    </section>
</template>

<script>
import scrollBar from "../../components/scroll-bar";

export default {
    name: "home-page01",

    components: {
        "scroll-bar": scrollBar
    },
    data: () => ({
        activeVideo_Index: -1,
    }),
    created() {
        
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.$utils.setVideoSize("#home-page01-video", ".home-page__01");
        }, false);
    },
    watch: {
    },
    computed: {
        VIDEO_TOP() {
            return this.$store.state.VIDEO_ARR.TOP;
            // return require("../../assets/video/top.mp4")
        },
        VIDEO_TOP_BG() {
            // return this.$store.state.VIDEO_BG.TOP;
            return require("../../assets/images/home/page01/top.png")
        }
    },
    methods: {
        loaded() {
            this.$utils.setVideoSize("#home-page01-video", ".home-page__01");
        },
        enter(index) {
            this.activeVideo_Index = index;
            if(this.$refs[`video-${index}`][0]) {   
                let playPromise = this.$refs[`video-${index}`][0].play();     //播放
                if (playPromise !== undefined) {
                    playPromise.then(_ => {
                    })
                    .catch(error => {
                        console.log(error)
                    });
                }
            }
        },
        leave(index) {
            this.activeVideo_Index = -1;
            if(this.$refs[`video-${index}`][0]) {
                this.$refs[`video-${index}`][0].pause();
                this.$refs[`video-${index}`][0].currentTime = 0;    // 停止
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.home-page__01 {
    background: url("/images/home/page01/bg.png") no-repeat;
    background-position: center;
    background-size: cover;
    overflow: hidden;
    position: relative;

    &::after {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
        position: absolute;
        z-index: 3;
    }

    .bg {
        position: absolute;
        width: auto;
        height: auto;
        min-width: 100%;
        min-height: 100%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
    }

    .logotip-wrap {
        width: pxTorem(475px);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -45%);
        z-index: 5;

        .logo {
            width: 300%;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
        }
        /* .tip {
            width: 120%;
            position: absolute;
            display: block;
            left: 50%;
            transform: translateX(-50%);
            cursor: pointer;
            margin-top: pxTorem(20px);

            img {
                width: 100%;
            }

            &::after {
                content: "";
                display: block;
                width: 100%;
                height: 100%;
                background: url("../../assets/images/home/page01/prelogin_actived.png") no-repeat center;
                background-size: 100%;
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
                transition: opacity, .3s;
            }

            &:hover::after {
                opacity: 1;
            }
        }
        .comingsoon {
            width: 120%;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);

            img {
                width: 100%;
            }
        } */
        .tip-wrap {
            width: pxTorem(550px);
            position: relative;
            left: 50%;
            transform: translateX(-50%);

            .tip-text {
                width: 100%;
            }
        }
        .download-btn-wrap {
            width: pxTorem(535px);
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            .download-img {
                width: 100%;
            }
            .download-a-wrap {
                position: absolute;
                width: 78%;
                height: 75%;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                display: flex;

                a {
                    display: block;
                    flex: 1;

                    &:nth-of-type(1) {
                        margin-right: pxTorem(20px);
                    }
                }
            }
        }
    }
    .slogan {
        position: absolute;
        height: 70%;
        top: 50%;
        transform: translateY(-50%);
        right: pxTorem(30px);
        z-index: 5;
    }
    
}
</style>
